
import {
  LOCALSTORAGE,
} from "./constants";
import {
  toast
} from "react-toastify";
import axios from "./lib/axios";
import LoaderManager from './context/LoaderManager';
import {
  decryptData
} from "./encryption_decryption";
import { HTTP_ERROR_MESSAGES, NETWORK_ERROR_MESSAGES, FALLBACK_ERROR } from "./errorMessages";
import { getString } from "./storage";

const REDIRECT_CODES = new Set([403, 404, 501, 502, 503]);
const axiosPrivate = axios;
axiosPrivate.interceptors.request.use(
  (config) => {
    const accessToken = getString(LOCALSTORAGE.ACCESS_TOKEN, true);
    const loginType = getString(LOCALSTORAGE.LOGIN_TYPE, true);
    if (accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
      config.headers["LoginType"] = loginType;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosPrivate.interceptors.response.use(
  (response) => response,
  async (error) => {
  const status: number | undefined = error?.response?.status;

    if (status === 401) {
      toast.error(HTTP_ERROR_MESSAGES[401]);
       sessionStorage.clear();
      setTimeout(() => {
          globalThis.location.replace("/login");
        }, 1500);
         return Promise.reject(error);
}
      if (status !== undefined) {
     
        
      if (REDIRECT_CODES.has(status)) {

         LoaderManager.redirect(String(status));
      }

        throw error
    } else {
    const networkMessage =
      NETWORK_ERROR_MESSAGES[error?.message] ?? FALLBACK_ERROR;
    toast.error(networkMessage);

      throw error
    }
  }
);

export default axiosPrivate;